// LLM generated - Model Claude 4 Sonnet
import useTranslation from 'next-translate/useTranslation';
import { z } from 'zod';

/**
 * Entry name validation regex
 * Allows: Latin characters, combining marks (accents), hyphens, numbers, and spaces
 * Examples of valid names: "Team Alpha", "José María", "Café Team", "A-Team 2023"
 * Examples of invalid names: "Invalid@Name", "Team 中文", "Test_underscore"
 */
export const ENTRY_NAME_REGEX = /^[\p{Script=Latin}\p{M}\-0-9 ]+$/gu;

/**
 * Hook to get entry validation schemas with internationalized error messages
 * For client-side validation in React components and forms
 */
export const useEntrySchema = () => {
  const { t } = useTranslation('entrants-manager');

  /**
   * Schema for entry name validation
   * Used in rename entry modals and forms
   */
  const entryName = z
    .string({
      required_error: t('validation.entryName.required'),
      invalid_type_error: t('validation.entryName.invalid'),
    })
    .trim()
    .min(1, {
      message: t('validation.entryName.required'),
    })
    .max(30, {
      message: t('validation.entryName.maxLength', { maxLength: 50 }),
    })
    .regex(ENTRY_NAME_REGEX, {
      message: t('validation.entryName.invalidCharacters'),
    });

  /**
   * Schema for rename entry form
   */
  const renameEntrySchema = z.object({
    entryName,
  });

  return {
    entryName,
    renameEntrySchema,
  };
};

/**
 * Type definitions for entry validation
 */
export type EntryNameSchema = ReturnType<typeof useEntrySchema>['entryName'];
export type RenameEntryFormValues = {
  entryName: string;
};
